import BaseAPIClient from './base/BaseAPIClient';

export default class DateTimeClient extends BaseAPIClient {
  getCurrentDateTime() {
    return this._get(`v2/platform/now`)
  }
}